/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const appointments = sqliteTable('appointments', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  clinic_id: text('clinic_id'),
  patient_id: text('patient_id'),
  provider_id: text('provider_id'),
  service_id: text('service_id'),
  status_id: text('status_id'),
  category_id: text('category_id'),
  date: text('date'),
  start_time: text('start_time'),
  duration_minutes: integer('duration_minutes'),
  notes: text('notes'),
  appointment_slot_id: text('appointment_slot_id'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
